import { takeEvery, takeLatest, call, put } from "redux-saga/effects";
import { MainFlowActionTypes, MainFlowAction } from "./types";
import { replace } from "connected-react-router";
import { API, links } from "@http";
import { generalErrorHandler } from "../rootSaga";
import { pullListSessions, getSessionDetailById } from "../sessions/actions";
import {
  setEmailList,
  setMainSources,
  setLoadingMainFlow,
  cleanLoadingMainFlow,
} from "./actions";

const HOME_LINK = "/sessions/verify-pin/";

function* cancelSessionMainFlowSaga({ payload }: MainFlowAction) {
  try {
    yield call(API.post, links.session.cancel(payload.id));
    yield put(pullListSessions());
    yield put(replace(HOME_LINK));
  } catch (error) {
    yield generalErrorHandler(error);
  }
}

function* getEmailListSaga({ payload }: MainFlowAction) {
  try {
    const requestData = {
      sessionId: payload.id,
    };
    const response = yield call(
      API.post,
      links.mainFlow.getEmailList,
      requestData
    );
    yield put(setEmailList(response.data.emails));
  } catch (error) {
    yield generalErrorHandler(error);
  }
}
function* getMainSourcesSaga({ payload }: MainFlowAction) {
  try {
    const requestData = {
      sessionId: payload,
    };
    const response = yield call(
      API.post,
      links.mainFlow.chooseSource,
      requestData
    );
    const { sessionSourcesToChoose, contactValue } = response.data;
    yield put(setMainSources(sessionSourcesToChoose, contactValue));
  } catch (error) {
    yield generalErrorHandler(error);
  }
}

function* confirmEmailMainFlowSaga({ payload }: MainFlowAction) {
  try {
    yield put(setLoadingMainFlow());
    const requestData = {
      sessionId: payload.id,
      email: payload.email,
    };
    yield call(API.post, links.mainFlow.confirmEmail, requestData);
    yield put(getSessionDetailById(payload.id));
    yield put(pullListSessions());
  } catch (error) {
    yield generalErrorHandler(error);
  } finally {
    yield put(cleanLoadingMainFlow());
  }
}

function* confirmMainSourcesSaga({ payload }: MainFlowAction) {
  try {
    yield put(setLoadingMainFlow());
    yield call(API.post, links.mainFlow.setSource, payload);
    yield put(getSessionDetailById(payload.sessionId));
    yield put(pullListSessions());
  } catch (error) {
    yield generalErrorHandler(error);
  } finally {
    yield put(cleanLoadingMainFlow());
  }
}

export default function* mainStateSaga() {
  yield takeLatest(
    MainFlowActionTypes.GET_EMAIL_LIST_FOR_MAIN_FLOW,
    getEmailListSaga
  );
  yield takeLatest(MainFlowActionTypes.CONFIRM_SOURCES, confirmMainSourcesSaga);

  yield takeEvery(
    MainFlowActionTypes.CANCEL_SESSION_MAIN_FLOW,
    cancelSessionMainFlowSaga
  );

  yield takeEvery(
    MainFlowActionTypes.CONFIRM_EMAIL_MAIN_FLOW,
    confirmEmailMainFlowSaga
  );
  yield takeEvery(MainFlowActionTypes.GET_SOURCES, getMainSourcesSaga);
}
